import { getPath } from '@/router/common'

const baseUrl = {
  title: '工单信息',
  path: 'WorkOrder'
}

export default [
    {
        path: getPath('Index', baseUrl),
        name: 'WorkOrder_Index',
        component: () => import(/* webpackChunkName: "WorkOrder_Index" */ '@/views/workOrder/index/index.vue'),
        meta: {
          title: '工单信息'
        }
    }
]
